import {
  FaTachometerAlt,
  FaUsers,
  FaProjectDiagram,
  FaFileInvoice,
  FaUserCog,
  FaUserPlus,
  FaUserShield,
  FaCubes,
  FaList,
  FaHistory,
  FaBook,
  FaChartPie,
  FaWarehouse,
  FaMoneyBill,
  FaUserTimes,
} from "react-icons/fa";

export const MENU = [
  {
    label: "Dashboard",
    path: "/admin",
    icon: FaTachometerAlt,
    roles: ["admin"],
  },

  {
    label: "View Clients",
    path: "/clients",
    icon: FaUsers,
    roles: ["admin", "manager", "hr"],
  },

  {
    label: "Projects",
    icon: FaProjectDiagram,
    roles: ["admin"],
    submenu: [
      {
        label: "View Projects",
        icon: FaProjectDiagram,
        path: "/projects",
        roles: ["admin"],
        permissions: ["project.view"],
      },
      {
        label: "Project Tracking",
        icon: FaProjectDiagram,
        path: "/boq",
        roles: ["admin"],
        permissions: ["project.view"],
      },
    ],
  },

  // {
  //   label: "View BOQs",
  //   path: "/boq",
  //   icon: FaFileInvoice,
  //   roles: ["admin", "manager"]
  // },

  {
    label: "View Vendors",
    path: "/vendors",
    icon: FaUsers,
    roles: ["admin", "manager"],
  },

  {
    label: "Stocks & Purchase Orders",
    icon: FaUserCog,
    roles: ["admin"],
    submenu: [
      {
        label: "Purchase Orders",
        path: "/purchase-orders",
        icon: FaFileInvoice,
        roles: ["admin", "manager"],
      },
      {
        label: "Tax Invoices",
        path: "/tax-invoices",
        icon: FaFileInvoice,
        roles: ["admin", "manager"],
      },
      {
        label: "DC-IN",
        path: "/dc-in",
        icon: FaFileInvoice,
        roles: ["admin", "manager"],
      },
      {
        label: "DC-OUT",
        path: "/dc-out",
        icon: FaFileInvoice,
        roles: ["admin", "manager"],
      },
      {
        label: "All Stocks",
        path: "/stock",
        icon: FaCubes,
        roles: ["admin", "manager"],
      },
    ],
  },

  {
    label: "Quality Management",
    icon: FaUserCog,
    roles: ["admin"],
    submenu: [
      {
        label: "Checklist",
        path: "/checklist",
        icon: FaFileInvoice,
        roles: ["admin", "manager"],
      },
      {
        label: "Inspections",
        path: "/inspections",
        icon: FaFileInvoice,
        roles: ["admin", "manager"],
      },

      {
        label: "NCR",
        path: "/ncr",
        icon: FaFileInvoice,
        roles: ["admin", "manager"],
      },
    ],
  },

  {
    label: "Billing Management",
    icon: FaUserCog,
    roles: ["admin"],
    submenu: [
      {
        label: "Billing Dashboard",
        path: "/billing",
        icon: FaFileInvoice,
        roles: ["admin", "manager"],
      },
      // {
      //   label: "Payment Details",
      //   path: "/payment-details",
      //   icon: FaFileInvoice,
      //   roles: ["admin", "manager"]
      // },
    ],
  },

  {
    label: "File Explorer",
    path: "/boq-attachment-status",
    icon: FaFileInvoice,
    roles: ["admin", "manager"],
  },

  {
    label: "Audit Logs",
    icon: FaUserCog,
    roles: ["admin"],
    submenu: [
      {
        label: "Module Audit",
        path: "/audit/module",
        icon: FaFileInvoice,
        roles: ["admin", "manager"],
      },
      {
        label: "Project Audit",
        path: "/audit/project",
        icon: FaFileInvoice,
        roles: ["admin", "manager"],
      },

      {
        label: "User Audit",
        path: "/audit/user",
        icon: FaFileInvoice,
        roles: ["admin", "manager"],
      },
    ],
  },
  {
    label: "Attendance Management",
    path: "/attendancemanagement",
    icon: FaUserTimes,
    roles: ["admin", "manager", "hr", "member"],
    submenu: [
      {
        label: "Attendance List",
        path: "/projects/${id}/attendance",
        icon: FaUserTimes,
        roles: ["admin", "manager", "hr", "member"],
      }
    ]
  },
  {
    label: "Manage Roles Users & Modules",
    icon: FaUserCog,
    roles: ["admin"],
    submenu: [
      {
        label: "Create Users",
        path: "/admin/users/create",
        icon: FaUserPlus,
        roles: ["admin"],
      },
      {
        label: "User List", // Changed from "Create Users" to "User List"
        path: "/admin/users/view", // This matches your Route path
        icon: FaList, // Changed icon to a List icon
        roles: ["admin"],
      },
      {
        label: "Create Role",
        path: "/admin/create-role",
        icon: FaUserShield,
        roles: ["admin"],
      },
      {
        label: "List Roles",
        path: "/admin/roles",
        icon: FaList,
        roles: ["admin"],
      },
      {
        label: "Create Module",
        path: "/admin/modules",
        icon: FaCubes,
        roles: ["admin"],
      },
      {
        label: "List Modules",
        path: "/admin/modules/list",
        icon: FaList,
        roles: ["admin"],
      },
      {
        label: "Assign Permissions",
        path: "/admin/assignpermissions",
        icon: FaList,
        roles: ["admin"],
      },
    ],
  },
  {
    label: "Login History",
    path: "/admin/users/history/:id", // Use :id as a placeholder
    icon: FaHistory,
    roles: ["admin", "manager", "hr", "stock", "accounts"],
  },
  // {
  //   label: "Dashboards",
  //   icon: FaChartPie,
  //   roles: ["admin"],
  //   submenu: [
  //     {
  //       label: "HR Dashboard",
  //       path: "/hr",
  //       icon: FaUsers,
  //       roles: ["hr", "admin"]
  //     },
  //     {
  //       label: "Stock Dashboard",
  //       path: "/stock",
  //       icon: FaWarehouse,
  //       roles: ["stock", "admin"]
  //     },
  //     {
  //       label: "Accounts Dashboard",
  //       path: "/accounts",
  //       icon: FaMoneyBill,
  //       roles: ["accounts", "admin"]
  //     }
  //   ]
  // },

  // {
  //   label: "User Manual",
  //   path: "https://kvplerp.com/app/user-manual",
  //   icon: FaBook,
  //   roles: ["admin", "manager", "hr", "stock", "accounts"],
  //   external: true,
  //   target: "_blank"
  // }

  {
    label: "Profile",
    path: "/profile",
    icon: FaBook,
    roles: ["admin", "manager", "hr", "stock", "accounts"],
  },

  {
    label: "User Manual",
    path: "https://kvplerp.com/kvplerp/usermanual/",
    icon: FaBook,
    roles: ["admin", "manager", "hr", "stock", "accounts"],
    external: true,
  }
];
